import type { ChatMessageListResponsePageAllOfThreeContentItemAllOfSenderBasicInfo } from './chatMessageListResponsePageAllOfThreeContentItemAllOfSenderBasicInfo';
import type { ChatMessageListResponsePageAllOfThreeContentItemAllOfSenderSocial } from './chatMessageListResponsePageAllOfThreeContentItemAllOfSenderSocial';

/**
 * 발신자 정보
 */
export type ChatMessageListResponsePageAllOfThreeContentItemAllOfSender = {
  /** 사용자 기본 정보 */
  basicInfo: ChatMessageListResponsePageAllOfThreeContentItemAllOfSenderBasicInfo;
  /** 소셜 관계 정보 */
  social?: ChatMessageListResponsePageAllOfThreeContentItemAllOfSenderSocial;
};
